import { useQuery } from '@tanstack/react-query';

import { getTcDocuments } from '@/services/tc.service';

// The three T&C documents for the admin/RM preview page. Static content, so
// cache generously.
export const useTcDocuments = () =>
  useQuery({
    queryKey: ['tc-documents'],
    queryFn: getTcDocuments,
    staleTime: 1000 * 60 * 60,
  });
